import { Link } from "@tanstack/react-router";
import { Compass } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { EmptyState } from "@/shared/ui/empty-state";

export function NotFoundPage() {
  return (
    <main className="min-h-screen w-full flex items-center justify-center bg-[hsl(var(--bg-page-wellness))] px-4">
      <EmptyState
        card
        icon={Compass}
        title="Página não encontrada"
        description="O endereço que você acessou não existe ou foi movido."
        action={
          <Link to="/">
            <Button className="rounded-full px-6">Voltar ao início</Button>
          </Link>
        }
      />
    </main>
  );
}
